import React, { Suspense, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'

import '../app/i18n'
import NotSignedInPageTemplate from '../common/components/NotSignedInPageTemplate'
import ResetCSS from '../common/components/ResetCSS'
import ColorProvider from '../common/providers/ColorProvider'
import GlobalStyle from '../globalStyle'
import LoginForm from './common/components/LoginForm'
import EmbraceHeartLoader from '../common/components/EmbraceHeartLoader'
import { InformationBanner } from '@/app/components/common/InformationBanner'

const container = document.getElementById('root')
const root = createRoot(container)
const queryClient = new QueryClient()

const App: React.FC = () => {
  useEffect(() => {
    const bc = new BroadcastChannel('email_session')
    bc.onmessage = ({ data }) => {
      if (!window.App?.user?.email && !!data && data !== 'session-expired') window.location.href = '/'
    }

    return () => {
      bc.close()
    }
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <InformationBanner />
      <ColorProvider>
        <Suspense fallback={<EmbraceHeartLoader loadingDots={{ enabled: true }} isFullPage />}>
          <ResetCSS />
          <GlobalStyle />
          <NotSignedInPageTemplate>
            <LoginForm />
          </NotSignedInPageTemplate>
        </Suspense>
      </ColorProvider>
    </QueryClientProvider>
  )
}

root.render(<App />)
